/**
 * @typedef {import('../index').ExportSettings} ExportSettings
 */

/**
 * @type {ExportSettings}
 */
export default {
  saveSettings: true,
  savedType: 'word',
  scrivener: {
    general: {},
    outline: {
      export: true,
      columnOrRow: 'column',
      sceneCards: true,
      plotlineInTitle: true,
      attachments: true,
      description: true,
      descriptionHeading: true,
      where: 'synopsis',
      customAttributes: true,
      templates: true,
      filter: null,
    },
    characters: {
      export: true,
      heading: true,
      description: true,
      descriptionHeading: true,
      attachments: true,
      notesHeading: true,
      notes: true,
      customAttributes: true,
      templates: true,
      tags: true,
      categoryHeading: true,
      category: true,
    },
    places: {
      export: true,
      heading: true,
      description: true,
      descriptionHeading: true,
      attachments: true,
      notesHeading: true,
      notes: true,
      customAttributes: true,
      tags: true,
    },
    notes: {
      export: true,
      heading: true,
      attachments: true,
      content: true,
    },
  },
  word: {
    general: {
      titlePage: true,
    },
    outline: {
      export: true,
      columnOrRow: 'column',
      heading: true,
      sceneCards: true,
      plotlineInTitle: true,
      attachments: true,
      description: true,
      customAttributes: true,
      templates: true,
      filter: null,
    },
    characters: {
      export: true,
      heading: true,
      images: true,
      descriptionHeading: true,
      description: true,
      attachments: true,
      notesHeading: true,
      notes: true,
      customAttributes: true,
      templates: true,
      categoryHeading: true,
      category: true,
    },
    places: {
      export: true,
      heading: true,
      images: true,
      descriptionHeading: true,
      description: true,
      attachments: true,
      notesHeading: true,
      notes: true,
      customAttributes: true,
      category: true,
    },
    notes: {
      export: true,
      heading: true,
      images: true,
      attachments: true,
      content: true,
      customAttributes: true,
      category: true,
    },
  },
}
